import { MenuItem } from "./HeaderMenuTypes";
import CollectionsMenuItem from "./menu-items/CollectionsMenuItem";
import PageMenuItem from "./menu-items/PageMenuIItem";
import LinkMenuItem from "./menu-items/LinkMenuItem";

interface HeaderMenuItemProps {
  item: MenuItem;
}

export default function HeaderMenuItem({ item }: HeaderMenuItemProps) {
  switch (item.menuItemType) {
    case "collection":
      return <CollectionsMenuItem item={item} />;
    case "page":
      return <PageMenuItem item={item} />;
    case "link":
      return <LinkMenuItem item={item} />;
    default:
      throw new Error(`Unknown menu item type ${item}`);
  }
}
